import { FormData } from "../../getData/getIndexedFormsData";

import { Section } from "@/components/Section/Section";
import { Modul_Formbuilder } from "@/wp/types/acf-module-types";
import { Content } from "@/components/Content/Content";
import { useSublinesVisibility } from "@/hooks/useSublinesOverlinesVisibility";
import { FormBuilderOptionsType } from "@/types/ModuleOptionsType";
import { columnSize } from "@/utils/layout/columnSize";
import Form from "./Form";

export type FormBuilderType = Modul_Formbuilder;

interface FormModuleProps {
  data: FormBuilderType;
  formData: FormData;
  friendlyCaptchaApplicationkey: string;
  formBulderOptions: FormBuilderOptionsType;
}

const FormModule = ({
  data,
  formData,
  friendlyCaptchaApplicationkey,
  formBulderOptions,
}: FormModuleProps) => {
  const { headline, headline_html_tag, content, overline, subline } =
    data.formbuilder;

  const {
    background_color_class,
    module_width,
    section_margin_class,
    section_padding_class,
    headline_text_align_class,
    text_align_class,
    id,
  } = data.layout;

  const { show_overline_subline, button_type, columns } = formBulderOptions;

  const columnClsses = columnSize(columns);

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline ?? "none",
  );

  return (
    <Section
      id={id}
      className={`${background_color_class} ${section_padding_class} ${section_margin_class}`}
      columnsClassName={`is-multiline is-centered`}
    >
      <div className={`column ${columnClsses}`}>
        <Content
          headline_text_align_class={headline_text_align_class ?? ""}
          text_align_class={text_align_class ?? ""}
          headline_html_tag={headline_html_tag}
          headline={headline}
          text={content || ""}
          frameless={module_width === "frameless"}
          link={false}
          overline={showOverline ? overline : ""}
          subline={showSubline ? subline : ""}
        />
        <div className="my-6">
          {/* <button
              style={{
                position: "fixed",
                top: 16,
                left: 16,
                zIndex: 1000,
              }}
              onClick={() => {
                setFormState(
                  (last) =>
                    // last === "init"
                    //   ? "success"
                    //   : last === "success"
                    //   ? "error"
                    //   : last === "error"
                    //   ? "init"
                    //   : "init"
                    "loading"
                );
              }}
            >
              toggle
            </button> */}
          <Form
            button_type={button_type}
            formData={formData}
            friendlyCaptchaApplicationkey={friendlyCaptchaApplicationkey}
          />
        </div>
      </div>
    </Section>
  );
};

export default FormModule;
